import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/api";
import { PriorityBadge } from "@/components/Badges";
import { fmtTime, fmtMinutes } from "@/lib/constants";
import { Building2, Archive as ArchiveIcon } from "lucide-react";

export default function Archive() {
  const navigate = useNavigate();
  const [incidents, setIncidents] = useState([]);

  useEffect(() => { api.get("/incidents?status=closed").then(({ data }) => setIncidents(data)); }, []);

  const duration = (inc) => {
    if (!inc.closed_at) return "—";
    const min = Math.round((new Date(inc.closed_at) - new Date(inc.created_at)) / 60000);
    return fmtMinutes(min);
  };

  return (
    <div className="space-y-5" data-testid="archive-page">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900">Archief</h1>
        <p className="text-sm text-slate-500">{incidents.length} gesloten incident(en)</p>
      </div>
      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-3">Ref</th><th className="px-4 py-3">Prio</th><th className="px-4 py-3">Titel</th>
              <th className="hidden px-4 py-3 md:table-cell">Gebouw</th><th className="hidden px-4 py-3 lg:table-cell">Aangemaakt</th>
              <th className="hidden px-4 py-3 lg:table-cell">Gesloten</th><th className="px-4 py-3">Duur</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {incidents.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-400"><ArchiveIcon className="mx-auto mb-2 h-6 w-6" />Geen gesloten incidenten</td></tr>}
            {incidents.map((inc) => (
              <tr key={inc.id} data-testid={`archive-row-${inc.id}`} onClick={() => navigate(`/incidenten/${inc.id}`)} className="cursor-pointer hover:bg-slate-50">
                <td className="px-4 py-3 font-mono text-xs text-slate-500">{inc.ref}</td>
                <td className="px-4 py-3"><PriorityBadge priority={inc.priority} /></td>
                <td className="px-4 py-3 font-medium text-slate-900">{inc.title}</td>
                <td className="hidden px-4 py-3 text-slate-600 md:table-cell"><span className="inline-flex items-center gap-1"><Building2 style={{ width: 13, height: 13 }} />{inc.building?.name}</span></td>
                <td className="hidden px-4 py-3 text-slate-500 lg:table-cell">{fmtTime(inc.created_at)}</td>
                <td className="hidden px-4 py-3 text-slate-500 lg:table-cell">{fmtTime(inc.closed_at)}</td>
                <td className="px-4 py-3 font-medium text-slate-700">{duration(inc)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
